export default {
  methods: {
    setMinNumber(e) {
      if (e.target.value < 0) e.target.value = 0;
    },
  }
};
